<template lang="pug">
div
  v-navigation-drawer.test(
    app
    left
    fixed
    temporary
    :value="value"
    @input="drawer => $emit('input', drawer)"
  )
    profile-menu(v-if="isMobile" :is-mobile="isMobile")
    v-list-item.pa-0(v-if="!isMobile" )
      v-spacer
      v-icon.primary--text(@click="$emit('toggle')") mdi-backburger
    v-list(
        expand
        v-for="menu in menus"
        :key="menu.title"
      )
      v-list-item(v-if="!menu.children" :to="{ path: menu.path }")
        v-img(v-if="menu.isImage && isMobile" :src="menu.icon")
        v-icon.primary--text(v-else) {{ menu.icon }}
        v-list-item-title.pl-8 {{ menu.title }}
      v-list-group(
        :prepend-icon="menu.icon"
        v-else
        value="group"
      )
        template(v-slot:activator)
          v-list-item-content
            v-list-item-title {{ menu.title }}
        .menu(v-for="child in menu.children")
          v-list-item.item(
            v-if="!child.children2"
            :key="child.title"
            link
            :to="{ path: child.path , query: child?.query }"
            :class="{ 'v-list-item--active': checkExact(child.path, child?.query), 'disableClick': checkActive(child.path, child?.query)}"
            :exact="child?.query ? true : false"
          )
            v-list-item-content
              v-list-item-title {{ child.title }}
          v-list-group(
            v-else
            no-action
            sub-group
            :value="true"
            :prepend-icon="child.children2 ? 'mdi-menu-down' : ''"
            :key="child.title"
            )
            template(v-slot:activator)
              v-list-item-content
                v-list-item-title(:class="child.children2 ? '' : 'no-icon'") {{ child.title }}
            v-list-item(
              v-for="child2 in child.children2"
              :key="child2.title"
              link
              :to="{ path: child2.path , query: child2?.query }"
              :class="{ 'v-list-item--active': checkExact(child2.path, child2?.query), 'disableClick': checkActive(child2.path, child2?.query)}"
              :exact="child2?.query ? true : false"
            )
              v-list-item-title {{ child2.title }}
    template(v-slot:append)
      v-divider
      v-list-item ver: {{ currentVersion }}
</template>

<script>
import { defineComponent, getCurrentInstance, ref, watch } from 'vue'
import { MENU, MOBILE_MENU } from './menu'
import router from '@/router'
import { useIsAdmin } from '@/composables/useIsAdmin'
import ProfileMenu from '@/components/JHeaderMenu/ProfileMenu.vue'
import { system_version } from '@/../package.json'

const JNavigationMenu = defineComponent({
  props: {
    value: {
      type: Boolean,
      required: true
    },
    isMobile: {
      type: Boolean,
      required: false,
      default: false
    }
  },
  components: { ProfileMenu },
  setup() {
    const { $vuetify } = getCurrentInstance().proxy
    const group = ref(null)
    const menus = ref(MENU)
    const { isAdmin } = useIsAdmin()
    const currentVersion = ref(system_version)

    watch(
      $vuetify.breakpoint,
      (newValue) => {
        if (newValue.width < 900) {
          menus.value = (MOBILE_MENU || MENU).filter(
            (i) =>
              // currentUser.enabled_jobs.includes(i.meta?.job_code)
              !i.adminOnly || isAdmin.value
          )
        } else {
          menus.value = MENU.map((i) => {
            if (i.children?.length) {
              i.children = i.children
                .map((i2) => {
                  if (i2.children2?.length) {
                    i2.children2 = i2.children2.filter((route) => {
                      // return currentUser.enabled_jobs.includes(
                      //   route?.meta?.job_code
                      // )
                      true
                    })
                  }
                  return i2
                })
                .filter(
                  (i2) =>
                    (!i2.adminOnly || isAdmin.value) &&
                    // eslint-disable-next-line no-prototype-builtins
                    (!i2.hasOwnProperty('children2') ||
                      // &&
                      // currentUser.enabled_jobs.includes(i2.meta?.job_code)) ||

                      i2.children2?.length)
                )
            }
            return i
            // eslint-disable-next-line no-prototype-builtins
          }).filter((i) => !i.hasOwnProperty('children') || i.children?.length)
        }
      },
      { immediate: true }
    )

    const onClickMenu = (menu) => {
      if (menu.name) {
        router.push({ name: menu.name })
      }
    }

    const checkExact = (path, query) => {
      const location = window.location
      if (query && path == location.pathname) {
        const params = new URLSearchParams(location.search)
        for (const [key, value] of params) {
          if (key in query && query[key].toString() == value.toString())
            return true
        }
      }
      return false
    }

    const checkActive = (path, query) => {
      if (path == window.location.pathname) {
        if (query) {
          const params = new URLSearchParams(window.location.search)
          for (const [key, value] of params) {
            if (key in query && query[key].toString() == value.toString())
              return true
          }
        } else return true
      }
      return false
    }

    return {
      group,
      menus,
      currentVersion,
      onClickMenu,
      checkExact,
      checkActive
    }
  }
})
export default JNavigationMenu
</script>

<style scoped lang="sass">
@import '@/style/css/common.sass'
.nav-hide
  z-index: 1000
  position: fixed
  text-align: left
  width: 18px
  background-color: rgba(111, 152, 111, 0.2) !important

  .v-icon
    font-size: x-large
    padding-right: 10px

  .btn-icon
    opacity: 0.5 !important
    background-color: #90CAF9
    position: absolute
    left: 2px
    top: 15px
    box-shadow: 0 0 2px 2px rgba(218, 216, 216, 0.49)

.nav-show
  position: absolute
  text-align: left
  height: 100vh
  width: 250px
  background-color: white

.title
  font-weight: bold
  color: var(--v-primary-base)
  font-size: 18px

.child
  .link
    color: $rough-black
    text-underline-position: under

  .text
    font-size: 18px

::v-deep .v-list
  .item
    padding-left: 48px
  .v-list-group__header
    .v-list-item__icon:first-child
      margin-right: 8px
      .v-list-group__header__append-icon
        min-width: 24px
  .v-list-group--sub-group > .v-list-group__items > .v-list-item
     padding-left: 72px

::v-deep .v-list .v-list-item--active
  color: var(--v-primary-base)

::v-deep .v-list-item .v-list-item__title
  color: $rough-black

.no-icon
  padding-left: 40px
.test
  background-color: white !important
  width: 300px !important
@media (max-width: 820px)
  .nav-hide
    width: 0

.disableClick
  pointer-events: none
</style>
